export default __webpack_public_path__ + "static/media/frankhomiese.55183f73.gif";